/** @jsxImportSource react */
import { StateAbbr } from '@common/data/povertyRate';
import { parseNeighborhoodSurveyData } from '@common/helpers/neighborhoodData';
import Accordian from '@react/profile/v2/Accordian';
import { LivabilityData } from '@sly/core/src/api/types/livabilityData';
import { capitalize } from '@sly/frontend/common/helpers/utils';
import { Care, Family, HomeSmallStroke, Info } from '@sly/icons/dist/react';
import dynamic from 'next/dynamic';
import { isBrowser } from 'sly/config';

const ReactTooltip = dynamic(() => import('react-tooltip'), {
  ssr: false,
});

const iconMap = {
  HomeSmallStroke: HomeSmallStroke,
  Care: Care,
};

export default function NeighborhoodSurvey({
  neighborhoodSurvey,
  stateAbbr,
  openByDefault = false,
}: {
  neighborhoodSurvey: LivabilityData;
  stateAbbr: StateAbbr;
  openByDefault?: boolean;
}) {
  if (!neighborhoodSurvey) {
    return null;
  }

  const parsedData = Object.entries(
    parseNeighborhoodSurveyData(neighborhoodSurvey, stateAbbr)
  );

  if (!parsedData.length) {
    return null;
  }

  return (
    <div className='space-y-2'>
      {parsedData.map(([key, value], index) => {
        return (
          <Accordian
            key={key}
            title={capitalize(key)}
            variant='A'
            openByDefault={openByDefault ? openByDefault : index === 0}
            eventProps={{
              location: 'neighborhood survey section',
              text: `NeighborhoodSurvey${capitalize(key)}`,
            }}
            className='p-4'
          >
            <div className='space-y-2'>
              {Object.values(value).map(
                ({ heading, subheading, Icon, tooltip }) => {
                  const IconComponent = Icon
                    ? iconMap[Icon as keyof typeof iconMap]
                    : Family;
                  return (
                    <div className='flex gap-4' key={heading}>
                      <IconComponent class='min-w-[32px]' />
                      <div className='space-y-1'>
                        <div className='flex gap-2'>
                          <h3>{heading}</h3>
                          {!!tooltip && (
                            <Info data-tip data-for={heading} size='m' />
                          )}
                          {!!tooltip && isBrowser && (
                            <>
                              <ReactTooltip
                                className='max-w-xs bg-white p-xs font-normal leading-5 text-slate-base shadow-sm'
                                id={heading}
                                type='light'
                                effect='solid'
                                multiline
                                clickable={true}
                              >
                                <div
                                  dangerouslySetInnerHTML={{ __html: tooltip }}
                                />
                              </ReactTooltip>
                            </>
                          )}
                        </div>

                        {subheading && (
                          <div className='text-slate-lighter-40'>
                            {subheading}
                          </div>
                        )}
                      </div>
                    </div>
                  );
                }
              )}
            </div>
          </Accordian>
        );
      })}
    </div>
  );
}
